import Mock from 'mockjs'

const {page, save} = require('../util');
const {initialData} = require('./data');
const qs = require('qs');

Mock.mock('/initialData/findAll', 'post', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    bodyObject.data = page(initialData, bodyObject);
    bodyObject.total = initialData.length;
    return {
        code: 200,
        body: bodyObject,
    }
});

